export var SalesRecordingStatus;
(function (SalesRecordingStatus) {
    SalesRecordingStatus["SoldStatus"] = "SOLD";
    SalesRecordingStatus["VerifiedStatus"] = "VERIFIED";
    SalesRecordingStatus["InvoicedStatus"] = "INVOICED";
    SalesRecordingStatus["ProcessingStatus"] = "PROCESSING";
    SalesRecordingStatus["ErrorStatus"] = "ERROR";
})(SalesRecordingStatus || (SalesRecordingStatus = {}));
export var SalesRecordingType;
(function (SalesRecordingType) {
    SalesRecordingType["General"] = "GENERAL";
    SalesRecordingType["CommissionAfterTravel"] = "COMMISSION_AFTER_TRAVEL";
    SalesRecordingType["TravelerReferral"] = "TRAVELER_REFERRAL";
    SalesRecordingType["PartnerRepeat"] = "PARTNER_REPEAT";
    SalesRecordingType["Adjustment"] = "ADJUSTMENT";
    SalesRecordingType["PlanningFee"] = "PLANNING_FEE";
    SalesRecordingType["RefundCredit"] = "REFUND_CREDIT";
})(SalesRecordingType || (SalesRecordingType = {}));
export var SalesRecordingAggregateStatus;
(function (SalesRecordingAggregateStatus) {
    SalesRecordingAggregateStatus["SalesRecordingAggregateStatusApproved"] = "APPROVED";
    SalesRecordingAggregateStatus["SalesRecordingAggregateStatusUnapproved"] = "UNAPPROVED";
    SalesRecordingAggregateStatus["SalesRecordingAggregateStatusInvoiced"] = "INVOICED";
    SalesRecordingAggregateStatus["SalesRecordingAggregateStatusError"] = "ERROR";
    SalesRecordingAggregateStatus["SalesRecordingAggregateStatusProcessing"] = "PROCESSING";
})(SalesRecordingAggregateStatus || (SalesRecordingAggregateStatus = {}));
